<div class="w-100 mb-sm-3">
  <div class="d-flex">
    <app-sidebar [products]="products" class="d-md-flex d-none sidebar-scroll" (selectedFilter)="applyFilter($event)"></app-sidebar>

    <div class="w-md-75 w-100">
      <section class="container-fluid">
        <app-top-filter [products]="products" (selectedFilter)="applyFilter($event)"></app-top-filter>
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-6 p-0" *ngFor="let listing of products">
            <app-product [product]="listing" [cartEnabled]="true"></app-product>
          </div>
          <div class="no-data-container text-center" *ngIf="!loading && products.length == 0">
            <div class="card no-data-card shadow">
              <div class="card-body">
                <h5 class="card-title text-danger">No Data Found</h5>
                <p class="card-text text-muted">Try modifying your search or filters to find what you're looking for.</p>
                <a role="button" [routerLink]="'/'"><button class="btn btn-sm btn-danger">Home</button></a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
